import React, { Fragment, useEffect, useState } from "react";
import { connect } from "react-redux";
import NewNavbar from "../../new-components/NewNavbar";
import NewPageHeader from "../../new-components/NewPageHeader";
import NewOverrides from "../../new-components/NewOverrides";
import NewDesignSystem from "../../new-components/NewDesignSystem";
import NewFooter from "../../new-components/NewFooter";
import NewMadeWith from "../../new-components/NewMadeWith";
import NewScrollTop from "../../new-components/NewScrollTop";
import { addToCart } from "../../store/actions/action";
import Product from "./product";
import api from "../../api";
import ProductTabs from "./alltab";

const ProductSinglePage = (props) => {
  const productsArray = api();
  const Allproduct = productsArray;

  const { addToCart } = props;
  const [product, setProduct] = useState({});

  useEffect(() => {
    setProduct(
      Allproduct.filter(
        (Allproduct) => Allproduct.id === Number(props.match.params.id)
      )
    );
  }, []);

  const item = product[0];

  const addToCartProduct = (product, qty = 1) => {
    addToCart(product, qty);
  };

  return (
    <Fragment>
      <NewNavbar />
      <NewOverrides />
      <NewDesignSystem />

      <NewPageHeader />
      <section className="wpo-shop-single-section section-padding">
        <div className="container">
          {item ? <Product addToCart={addToCartProduct} /> : null}
          {/* <ProductTabs /> */}
        </div>
      </section>
      <NewFooter />
      <NewMadeWith />
      <NewScrollTop />
    </Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    products: state.data.products,
  };
};

export default connect(mapStateToProps, { addToCart })(ProductSinglePage);
